import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Card, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getLead, updateLead } from "../../store/slices/leads";
import { emailregex, mobileregex } from "../../utils/Regex";
import { useNavigate, Link, useParams } from "react-router-dom";
import { getAgent } from "../../store/slices/agent";
import Select from "react-select";
import "react-international-phone/style.css";
import { PhoneInput } from "react-international-phone";

export default function EditLeads() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();

  // fetchlead data
  const fetchLead = async () => {
    try {
      const response = await dispatch(getLead({ id })).unwrap();

      const data = response?.leads?.[0];

      setLead({
        name: data.name || "",
        email: data.email || "",
        phone: data.phone || "",
        country: data.country || "",
        city: data?.city || "",
        source: data.source || "",
        sourceReference: data.sourceReference || "",
        tentativeTravelDate: formatDate(data.tentativeTravelDate),
        durationNights:
          data.durationNights != null ? data.durationNights.toString() : "",
        adults: data.adults != null ? data.adults.toString() : "",
        children: data.children != null ? data.children.toString() : "",
        budget: data.budget != null ? data.budget.toString() : "",

        priority: data.priority || "",
        notes: data.notes || "",
        agentId: data.agentId || "",
        countryCode: data?.countryCode || ""
      });
    } catch (error) {
      console.error("Failed to fetch lead", error);
    }
  };

  useEffect(() => {
    fetchLead();
  }, []);

  const [agents, setAgents] = useState([]);

  useEffect(() => {
    dispatch(getAgent())
      .unwrap()
      .then((res) => {
        setAgents(res?.agents || []);
      });
  }, [dispatch]);

  const agentOptions = agents.map((a) => ({
    value: a._id,
    label: `${a.name}`,
  }));

  const initialState = {
    name: "",
    email: "",
    phone: "",
    country: "",
    city: "",
    source: "",
    sourceReference: "",
    tentativeTravelDate: "",
    durationNights: "",
    adults: "",
    children: "",
    budget: "",
    priority: "",
    notes: "",
    agentId: "",
  };

  const [lead, setLead] = useState(initialState);

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  // convert date format
  const formatDate = (date) => {
    if (!date) return "";
    return date.split("T")[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let error = "";

    if (name === "name") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter name";
      } else if (updatedValue.length > 30) {
        error = "Name maximum 30 characters only";
      }
    }

    if (name === "email") {
      updatedValue = value;

      if (!updatedValue.trim()) {
        error = "Please enter email";
      } else if (updatedValue.includes(" ")) {
        error = "Email should not contain spaces";
      } else if (!emailregex.test(updatedValue)) {
        error = "Please enter valid email";
      } else if (!/^[^\s@]+@[^\s@]+\.com$/.test(updatedValue)) {
        error = "Email must end with .com";
      }
    }

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter phone number";
      } else if (!mobileregex.test(updatedValue)) {
        error = "Please enter valid 10 digit number";
      }
    }

    if (name === "country") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter country";
      } else if (updatedValue.length > 30) {
        error = "Country maximum 30 characters only";
      }
    }

    if (name === "city") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter city";
      } else if (updatedValue.length > 30) {
        error = "City maximum 30 characters only";
      }
    }

    if (name === "source") {
      updatedValue = value;

      if (!updatedValue.trim()) {
        error = "Please enter source";
      } else if (updatedValue.length > 20) {
        error = "Source maximum 30 characters only";
      }
    }


    if (name === "tentativeTravelDate") {
      const today = new Date().toISOString().split("T")[0];

      if (!updatedValue) {
        error = "Please select travel date";
      } else if (updatedValue < today) {
        error = "Past date is not allowed";
      }
    }

    if (name === "durationNights") {
      updatedValue = value.replace(/\D/g, "");

      if (!String(!updatedValue.trim())) {
        error = "Please enter duration nights";
      }
    }

    if (name === "adults") {
      updatedValue = value.replace(/\D/g, "");

      if (updatedValue.length > 2) {
        updatedValue = updatedValue.slice(0, 2);
      }

      if (!updatedValue.trim()) {
        error = "Please enter adults";
      }
    }

    if (name === "children") {
      updatedValue = value.replace(/\D/g, "");

      if (updatedValue.length > 2) {
        updatedValue = updatedValue.slice(0, 2);
      }

      if (!updatedValue.trim()) {
        error = "Please enter children";
      }
    }

    if (name === "budget") {
      updatedValue = value.replace(/\D/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter budget";
      } else {
        const numericValue = Number(updatedValue);

        if (numericValue < 20000) {
          error = "Budget must be minimum 10000";
        } else if (numericValue > 500000) {
          error = "Budget cannot exceed 500000";
        }
      }
    }

    if (name === "priority") {
      if (!updatedValue.trim()) {
        error = "Please select priority";
      }
    }

    if (name === "notes") {
      if (updatedValue.length > 1000) {
        error = "Notes maximum 1000 characters only";
      }
    }

    setLead((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateLead = () => {
    let newErrors = {};

    if (!lead.name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!lead.email.trim()) {
      newErrors.email = "Please enter email";
    }

    const phoneNumber = lead.phone.replace(/\D/g, "");

    if (!phoneNumber || phoneNumber.length <= 2) {
      newErrors.phone = "Please enter phone number";
    } else if (!mobileregex.test(phoneNumber.slice(-10))) {
      newErrors.phone = "Please enter valid 10 digit number";
    }

    if (!lead.country.trim()) {
      newErrors.country = "Please enter country";
    }

    if (lead.source === "B2B Agent" && !lead.agentId) {
      newErrors.agentId = "Please select agent";
    }

    if (!lead.source.trim()) {
      newErrors.source = "Please enter source";
    }


    if (!lead.tentativeTravelDate) {
      newErrors.tentativeTravelDate = "Please select travel date";
    }

    if (!String(lead.durationNights).trim()) {
      newErrors.durationNights = "Please enter duration nights";
    }

    if (!lead.adults.trim()) {
      newErrors.adults = "Please enter adults";
    }

    if (!lead.children.trim()) {
      newErrors.children = "Please enter children";
    }

    if (!lead.budget.trim()) {
      newErrors.budget = "Please enter budget";
    }

    if (!lead.priority.trim()) {
      newErrors.priority = "Please select priority";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    const validationErrors = validateLead();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id,
        ...lead,
      };

      await dispatch(updateLead(payload)).unwrap();

      toast.success("Lead Update successfully!");

      navigate("/admin/lead");
      setLead(initialState);

      setErrors({});
    } catch (error) {
      toast.error(error || "Failed to update lead");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-3">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          |
          <Link to="/admin/lead" className="breadcrumb-link active">
            Leads
          </Link>
          | <span className="breadcrumb-link inactive">Edit Lead</span>
        </div>
      </div>

      <Container className="mt-4">
        <Card style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="my-2">
                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      name="name"
                      value={lead.name}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter name"
                    />
                    <small className="text-danger">{errors.name}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      name="email"
                      value={lead.email}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter email"
                    />
                    <small className="text-danger">{errors.email}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Phone</Form.Label>
                    <PhoneInput
                      defaultCountry="in"
                      forceDialCode
                      value={lead.phone}
                      onChange={(phone, meta) => {
                        const phoneNumber = phone.replace(/\D/g, "");
                        let error = "";

                        if (!phoneNumber || phoneNumber.length <= meta.country.dialCode.length) {
                          error = "Please enter phone number";
                        } else if (!mobileregex.test(phoneNumber.slice(-10))) {
                          error = "Please enter valid 10 digit number";
                        }

                        setLead((prev) => ({
                          ...prev,
                          phone,
                          countryCode: `+${meta.country.dialCode}`,
                        }));

                        setErrors((prev) => ({
                          ...prev,
                          phone: error,
                        }));
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "38px",
                      }}
                      style={{
                        width: "100%",
                      }}
                    />
                    <small className="text-danger">{errors.phone}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      name="city"
                      value={lead.city}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter city"
                    />
                    <small className="text-danger">{errors.city}</small>
                  </Form.Group>
                </Col>


                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      name="country"
                      value={lead.country}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter country"
                    />
                    <small className="text-danger">{errors.country}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Source</Form.Label>
                    <Form.Select
                      name="source"
                      value={lead.source}
                      onChange={handleChange}
                    >
                      <option>Select</option>
                      <option value="Website">Website</option>
                      <option value="Walk-in">Walk-in</option>
                      <option value="Google">Google</option>
                      <option value="Referral">Referral</option>
                      <option valuue="B2B Agent">B2B Agent</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Advertisement">Advertisement</option>
                      <option value="Email Campaign">Email Campaign</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                    <small className="text-danger">{errors.source}</small>
                  </Form.Group>
                </Col>
                {lead.source === "B2B Agent" && (
                  <Col md={3} className="p-2">
                    <Form.Group>
                      <Form.Label>Select Agent</Form.Label>

                      <Select
                        options={agentOptions}
                        placeholder="Search and select agent..."
                        value={agentOptions.find(
                          (opt) => opt.value === lead.agentId,
                        )}
                        onChange={(selected) =>
                          setLead((prev) => ({
                            ...prev,
                            agentId: selected?.value || "",
                          }))
                        }
                        isClearable
                      />

                      <small className="text-danger">{errors.agentId}</small>
                    </Form.Group>
                  </Col>
                )}

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Source Reference</Form.Label>
                    <Form.Control
                      name="sourceReference"
                      value={lead.sourceReference}
                      onChange={handleChange}
                      maxLength={20}
                      placeholder="Enter source reference"
                    />
                    <small className="text-danger">
                      {errors.sourceReference}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Travel Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="tentativeTravelDate"
                      value={lead.tentativeTravelDate}
                      onChange={handleChange}
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <small className="text-danger">
                      {errors.tentativeTravelDate}
                    </small>
                  </Form.Group>
                </Col>
                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Duration Nights</Form.Label>
                    <Form.Control
                      name="durationNights"
                      value={lead.durationNights}
                      onChange={handleChange}
                      placeholder="Enter duration nights "
                      maxLength={10}
                    />
                    <small className="text-danger">
                      {errors.durationNights}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Adults</Form.Label>
                    <Form.Control
                      name="adults"
                      value={lead.adults}
                      onChange={handleChange}
                      maxLength={2}
                      placeholder="Enter adults "
                    />
                    <small className="text-danger">{errors.adults}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Children</Form.Label>
                    <Form.Control
                      name="children"
                      value={lead.children}
                      onChange={handleChange}
                      maxLength={2}
                      placeholder="Enter children"
                    />
                    <small className="text-danger">{errors.children}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Budget</Form.Label>
                    <Form.Control
                      name="budget"
                      value={lead.budget}
                      onChange={handleChange}
                      placeholder="Enter budget"
                      maxLength={6}
                    />
                    <small className="text-danger">{errors.budget}</small>
                  </Form.Group>
                </Col>

                <Col md={3} className="p-2">
                  <Form.Group>
                    <Form.Label>Priority</Form.Label>
                    <Form.Select
                      name="priority"
                      value={lead.priority}
                      onChange={handleChange}
                    >
                      <option value="">Select Priority</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </Form.Select>
                    <small className="text-danger">{errors.priority}</small>
                  </Form.Group>
                </Col>

                <Col lg={12}>
                  <Form.Group>
                    <Form.Label>Notes (Optional)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="notes"
                      value={lead.notes}
                      onChange={handleChange}
                      maxLength={100}
                      placeholder="Enter notes"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="text-center mt-5 mb-5">
                <button
                  type="button"
                  className="cancel-btn me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
